module.exports = __webpack_public_path__ + "static/media/home.2f5ffe90.svg";